module.exports = __webpack_public_path__ + "img/JP.72ee3260.png";